import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from "react-router-dom";
import * as serviceWorker from './serviceWorker';

import AppWithAuth from './components/Auth/AppWithAuth';
import DataContainer from "./containers/DataContainer";

import { MuiPickersUtilsProvider } from 'material-ui-pickers';
import MomentUtils from '@date-io/moment';
import moment from "moment";
import "moment/locale/pt-br";

import * as Sentry from '@sentry/browser';

import config from './config.json';
import info from '../package.json'

import './index.css';


moment.locale("pt-br");

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    dsn: config.sentryDSN,
    release: info.version
  });
}

ReactDOM.render(
  <Router>
    <MuiPickersUtilsProvider utils={MomentUtils} locale="pt-br" moment={moment}>
      <DataContainer>
        <AppWithAuth/>
      </DataContainer>
    </MuiPickersUtilsProvider>
  </Router>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
